/* KENZ — transforme l'accordéon de la fiche produit en ONGLETS (facon Merrachi) */
(function(){
  'use strict';
  function initTabs(){
    var containers = document.querySelectorAll('.product-information .accordion');
    containers.forEach(function(container){
      if (container.dataset.kenzTabs) return;
      var rows = Array.prototype.slice.call(container.querySelectorAll('.details'));
      if (rows.length < 1) return;

      // on ne garde que les onglets dont le contenu n'est pas vide
      var visibleRows = rows.filter(function(row){
        var content = row.querySelector('.details-content');
        var txt = content ? content.textContent.replace(/\s+/g,'').trim() : '';
        if (txt.length === 0){
          row.style.display = 'none';   // masque l'onglet vide (ex: Tailles non rempli)
          return false;
        }
        return true;
      });
      if (visibleRows.length < 1) return;
      container.dataset.kenzTabs = '1';

      var nav = document.createElement('div');
      nav.className = 'kenz-tabs';

      visibleRows.forEach(function(row, i){
        var summary = row.querySelector('summary');
        var label = '';
        if (summary){
          var clone = summary.cloneNode(true);
          clone.querySelectorAll('.svg-wrapper, svg').forEach(function(s){ s.remove(); });
          label = clone.textContent.trim();
        }
        if (!label) label = 'Onglet ' + (i+1);

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'kenz-tab';
        btn.textContent = label;
        btn.addEventListener('click', function(){
          visibleRows.forEach(function(r){ r.open = false; });
          row.open = true;
          nav.querySelectorAll('.kenz-tab').forEach(function(b){ b.classList.remove('is-active'); });
          btn.classList.add('is-active');
        });
        nav.appendChild(btn);

        if (i === 0){ btn.classList.add('is-active'); row.open = true; }
        else { row.open = false; }
      });

      container.insertBefore(nav, container.firstChild);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTabs);
  else initTabs();

  var mo = new MutationObserver(function(){ initTabs(); });
  mo.observe(document.body, { childList:true, subtree:true });
})();
